import Header from "../../components/header/Header";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import SideBar from "../../components/sideBar/SideBar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./auditor.css";

const AddAuditor = () => {
  const [isAdding, setIsAdding] = useState(false);
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [formData, setFormData] = useState({
    userId: "",
    name: "",
    email: "",
    mobile: "",
    password: "",
  });

  const handleStatusChange = () => {
    setStatus(!status);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const userDetails = sessionStorage.getItem("adminInfo");
  const userInfo = JSON.parse(userDetails);

  useEffect(() => {
    if (sessionStorage.getItem("adminInfo") === null) {
      navigate("/admin/login");
    }
  }, []);
  // categories api

  const validation = () => {
    let valid = true;
    if (formData.userId === "") {
      toast.error("User Id must be require !");
      valid = false;
    } else if (formData.name === "") {
      toast.error("Name must be require !");
      valid = false;
    } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      toast.error("Name should only contain letters");
      valid = false;
    } else if (formData.email === "") {
      toast.error("Email address must be require");
      valid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      toast.error("Mobile no. must be a 10-digit number");
      valid = false;
    } else if (formData.password === "") {
      toast.error("Password must be require");
      valid = false;
    }
    return valid;
  };

  const handleAddAuditor = async (event) => {
    event.preventDefault();
    const { userId, name, email, mobile, password } = formData;
    if (!validation()) {
      return;
    }
    setIsAdding(true);
    const finalData = {
      user_id: userId,
      name: name,
      email: email,
      mobile: mobile,
      password: password,
      status: status ? "Y" : "N",
    };
    // console.log("add auditor finalData", finalData);
    try {
      const response = await axios.post(
        API_BASE_URL + "admin/add_auditor",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("add auditor response", response.data);
      if (response.data.status) {
        toast.success(response.data.message);
        setIsAdding(false);
        setTimeout(() => {
          navigate("/admin/manage-auditor");
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <Header />
      <section className="auditorMain">
        <SideBar />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="auditorDataTableBox">
                <div className="auditorTitleBox">
                  <h5>Add Auditor</h5>
                </div>
                <div className="auditorMainFormSec">
                  <form
                    className="addAuditorForm"
                    name="addAuditor"
                    id="addAuditor"
                    onSubmit={handleAddAuditor}
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="auditorGroup">
                          <label htmlFor="">User Id :-</label>
                          <input
                            type="text"
                            name="userId"
                            value={formData.userId}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="auditorGroup">
                          <label htmlFor="">Name :-</label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="auditorGroup">
                          <label htmlFor="">Email :-</label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="auditorGroup">
                          <label htmlFor="">Mobile :-</label>
                          <input
                            type="text"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="auditorGroup">
                          <label htmlFor="">Password :-</label>
                          <input
                            type="text"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="auditorGroup">
                          <label htmlFor="">Status :-</label>
                          <input
                            type="checkbox"
                            checked={status}
                            onChange={handleStatusChange}
                            className=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="auditorBtnGroup">
                          {!isAdding ? (
                            <button className="btn">Add</button>
                          ) : (
                            <button disabled className="btn">
                              Adding
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer
            position={"top-right"}
            autoClose={2000}
            pauseOnHover={false}
            closeOnClick={true}
          />
        </div>
      </section>
    </>
  );
};

export default AddAuditor;
